import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';


export const Sidebar = styled('aside')`
  width: 100%;
  border-right: 1px solid #ede7f3;
  position: fixed;
  padding-left: 24px;
  position: -webkit-sticky;
  position: -moz-sticky;
  position: sticky;
  top: 0;
  padding-top: 24px;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 0.95rem;
  line-height: 1.6;

  background: ${props => props.theme?.colors?.background || '#FFFFFF'};

  .rightSideTitle {
    font-size: 10px;
    line-height: 1;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    padding: 7px 24px 7px 16px;
    border-left: 1px solid #e6ecf1;
    border-left-color: rgb(230, 236, 241);

    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  }

  .rightSideBarUL {
    margin-top: 32px;
  }

  .rightSideBarUL li {
    list-style-type: none;
    border-left: 1px solid #e6ecf1;
    border-left-color: rgb(230, 236, 241);
  }

  .rightSideBarUL li a {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
    padding: 7px 24px 7px 16px;

    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  }

  @media only screen and (max-width: 50rem) {
    width: 100%;
    position: relative;
  }
`;

export const ListItem = styled(({ className, active, level, onClick, ...props }) => { // onClick を props から受け取る
  return (
    <li className={className}>
      <Link to={props.to} onClick={onClick} {...props}> {/* onClick を Link タグに設定 */}
        {props.children}
      </Link>
    </li>
  );
})`
  list-style: none;

  a {
    color: #444;
    text-decoration: none;
    font-weight: ${({ level }) => (level === 0 ? 600 : 400)};
    padding: 0.4rem 0 0.4rem ${({ level }) => 1 + (level || 0) * 1.2}rem;
    display: block;
    position: relative;
    transition: all 0.2s;

    &:hover {
      color: #1ed3c6;
      background-color: #f0f4f8;   // 例: 背景色を少し変える
    }

    ${props =>
    props.active &&
    `
      color: #1ED3C6;
      border-color: rgb(230,236,241) !important;
      border-style: solid none solid solid;
      border-width: 1px 0px 1px 1px;
      background-color: #fff;
    `} // external link icon
    svg {
      float: right;
      margin-right: 1rem;
    }
  }
`;
